import { create } from 'zustand'
import i18n from '../i18n'

interface LanguageStore {
  uiLanguage: 'vi' | 'en'
  langSuggestionShown: boolean
  setUiLanguage: (lang: 'vi' | 'en') => void
  setLangSuggestionShown: (shown: boolean) => void
}

export const useLanguageStore = create<LanguageStore>((set) => ({
  uiLanguage: (localStorage.getItem('ui_lang') as 'vi' | 'en') ?? 'vi',
  langSuggestionShown: false,
  setUiLanguage: (lang) => {
    localStorage.setItem('ui_lang', lang)
    i18n.changeLanguage(lang)
    set({ uiLanguage: lang })
  },
  setLangSuggestionShown: (shown) => set({ langSuggestionShown: shown }),
}))
